import { FilterAction } from '@anytag/shared-types';
import { Filter } from '../filter';
import { Template, TemplateProps } from './template';
import { KeywordFilterFormValues } from './types';

export type KeywordFilterProps = Omit<React.ComponentProps<typeof Filter.Provider>, 'children'> &
  Omit<TemplateProps, 'onSubmit'> &
  FilterAction<KeywordFilterFormValues>;

export const KeywordFilter = ({ filter, setFilter, placeholder, children, ...restProps }: KeywordFilterProps) => (
  <Filter.Provider values={filter} onSubmit={setFilter} {...restProps}>
    <Template placeholder={placeholder}>{children}</Template>
  </Filter.Provider>
);

export * from './types';
